module.exports = __webpack_public_path__ + "img/logo-bej.82f1259f.png";